<div class="shipment-details-cols">
  <ng-container [ngTemplateOutlet]="colItem" [ngTemplateOutletContext]="{ header: 'MENU.VOYAGES', body: voyageDetails }"></ng-container>
  <ng-template #voyageDetails>
    <div class="shipment-detail-col-body-item">
      <div class="shipment-detail-col-body-item-header">
        {{ "LABELS.VOYAGE_NUMBER" | translate }}
      </div>
      <div class="shipment-detail-col-body-item-value">
        {{ shipment?.voyage?.voyageNumber }}
      </div>
    </div>
    <div class="shipment-detail-col-body-item">
      <div class="shipment-detail-col-body-item-header">
        {{ "LABELS.VESSEL_NAME" | translate }}
      </div>
      <div class="shipment-detail-col-body-item-value">
        {{ shipment?.voyage?.vesselName }}
      </div>
    </div>
  </ng-template>

  <ng-container
    [ngTemplateOutlet]="colItem"
    [ngTemplateOutletContext]="{ header: 'LABELS.CONTAINER_DETAILS', body: containerDetails }"
  ></ng-container>
  <ng-template #containerDetails>
    <div class="shipment-detail-col-body-item">
      <div class="shipment-detail-col-body-item-header">
        {{ "LABELS.CONTAINER_NUMBER" | translate }}
      </div>
      <div class="shipment-detail-col-body-item-value">
        {{ shipment?.container?.containerNumber ? shipment?.container?.containerNumber : ("LABELS.NA" | translate) }}
      </div>
    </div>
    <div class="shipment-detail-col-body-item">
      <div class="shipment-detail-col-body-item-header">
        {{ "LABELS.SHIPMENT_TYPE" | translate }}
      </div>
      <div class="shipment-detail-col-body-item-value">
        {{ "MENU.LCL" | translate }}
      </div>
    </div>
  </ng-template>

  <ng-container
    [ngTemplateOutlet]="colItem"
    [ngTemplateOutletContext]="{ header: 'LABELS.BILL_OF_LADING', body: billOfLading, id: 'billOfLading', isLastItem: true }"
  ></ng-container>
  <ng-template #billOfLading>
    <div class="d-flex">
      <div class="shipment-detail-col-body-item">
        <div class="shipment-detail-col-body-item-header">
          {{ "LABELS.MBL_SCAC" | translate }}
        </div>
        <div class="shipment-detail-col-body-item-value">
          {{ shipment?.container?.billNumber?.carrier ? shipment?.container?.billNumber?.carrier : ("LABELS.NA" | translate) }}
        </div>
      </div>
      <div class="shipment-detail-col-body-item">
        <div class="shipment-detail-col-body-item-header">
          {{ "LABELS.MBL_NUMBER" | translate }}
        </div>
        <div class="shipment-detail-col-body-item-value">
          {{ shipment?.container?.billNumber?.number ? shipment?.container?.billNumber?.number : ("LABELS.NA" | translate) }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="shipment-detail-col-body-item">
        <div class="shipment-detail-col-body-item-header">
          {{ "LABELS.HBL_SCAC" | translate }}
        </div>
        <div class="shipment-detail-col-body-item-value">
          {{ shipment?.houseBill?.carrier ? shipment?.houseBill?.carrier : ("LABELS.NA" | translate) }}
        </div>
      </div>
      <div class="shipment-detail-col-body-item">
        <div class="shipment-detail-col-body-item-header">
          {{ "LABELS.HBL_NUMBER" | translate }}
        </div>
        <div class="shipment-detail-col-body-item-value">
          {{ shipment?.houseBill?.number ? shipment?.houseBill?.number : ("LABELS.NA" | translate) }}
        </div>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #colItem let-header="header" let-body="body" let-isLastItem="isLastItem">
  <div class="shipment-detail-col" [ngClass]="{ 'last-item': isLastItem }">
    <div class="shipment-detail-col-header" *ngIf="!!header">
      <h5>{{ header | translate }}</h5>
    </div>

    <div class="shipment-detail-col-body">
      <ng-container *ngTemplateOutlet="body"></ng-container>
    </div>
  </div>
</ng-template>
